import { Routes, Route } from 'react-router-dom'
import Layout from './components/layout/Layout'
import Home from './pages/Home'
import BlogPost from './pages/BlogPost'
import About from './pages/About'
import Operations from './pages/Operations'
import Exploits from './pages/Exploits'
import Comms from './pages/Comms'
import './styles/index.css'

function App() {
  return (
    <div className="min-h-screen relative m-0 p-0">
      <Routes>
        <Route path="/" element={<Layout />}>
          <Route index element={<Home />} />
          <Route path="/post/:slug" element={<BlogPost />} />
          <Route path="/about" element={<About />} />
          <Route path="/operations" element={<Operations />} />
          <Route path="/exploits" element={<Exploits />} />
          <Route path="/comms" element={<Comms />} />
        </Route>
      </Routes>
    </div>
  )
}

export default App
